import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

import {
  IConfigurationCityDetailsPincodeResponse,
  IConfigurationCityDetailsPincodeResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationCityDetailByPincodeAPI = () => {
  const [cityByPincode, setCityDataByPincode] = useState<IConfigurationCityDetailsPincodeResponseData | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (pincode: number) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!pincode) {
          return;
        }
        await axios
          .get(`${CONFIGURATION_APIS?.CITY_DETAILS_BY_PINCODE?.baseURL}${pincode}/`, {
            // params: { pincode },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationCityDetailsPincodeResponse>) => {
            if (res.data.status === true) {
              setCityDataByPincode(res.data.data);
            } else {
              toast.error("Failed to fetch city details by pincode");
            }
          })
          .catch((e: AxiosError) => {
            toast.error("Pincode is invalid");
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.response?.status === 400) {
            toast.error("Pincode is invalid");
          } else if (axiosError.response.status === 500) {
            toast.error("Internal Server Error while fetching city detail using pincode");
          } else if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching city details.");
          }
          // else if (axiosError.response?.status === 400) {
          //   toast.error(axiosError.message);
          // }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { cityByPincode, execute };
};
